import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { useTerminalStepJustifiContext } from '../../terminals/terminal-step-context/terminal-step-context-justifi';
import { useTerminalReadersQuery } from '../../terminals/use-terminal-readers-query';
import { useTerminalSelectionData } from '../../terminals/use-terminal-selection-data';
import { SelectTerminalNavigationSwitch } from './select-terminal-navigation-switch';
import { SelectTerminalStep } from './select-terminal-step';
import { SelectTerminalStepBodyProps } from './select-terminal.types';

export const SelectTerminalJustifi = () => {
  return <SelectTerminalNavigationSwitch body={SelectTerminalJustifiBody} />;
};

const SelectTerminalJustifiBody = ({
  onGoBack,
  onReaderSelected,
  onClickRegisterTerminal,
}: SelectTerminalStepBodyProps) => {
  const {
    activeLocationId,
    justifiData: { canRegisterTerminals },
  } = useCollectPaymentMultiContext();

  const { selectedReader, setSelectedReader, tempReader, setTempReader } = useTerminalStepJustifiContext();

  const { readers, isReadersLoading, refetchReaders } = useTerminalReadersQuery({
    locationId: activeLocationId,
  });

  const { modalProps, showLocationChip, handleReaderSelect, locationName, onConfirm } = useTerminalSelectionData({
    readers,
    tempReader,
    selectedReader,
    locationId: activeLocationId,
    onSelectReader: (reader) => {
      setSelectedReader(reader);
      onReaderSelected(reader);
    },
    onSelectTempReader: (reader) => {
      setTempReader(reader);
    },
  });

  return (
    <SelectTerminalStep
      readers={readers}
      isReadersLoading={isReadersLoading}
      showLocationChip={showLocationChip}
      locationName={locationName}
      confirmModalProps={modalProps}
      canRegisterTerminals={canRegisterTerminals}
      onGoBack={onGoBack}
      refetchReaders={refetchReaders}
      onClickRegisterTerminal={onClickRegisterTerminal}
      onClickSelectReader={handleReaderSelect}
      onClickConfirmPayment={onConfirm}
    />
  );
};
